(() => {
  const initialize = root => {
    if (root.dataset.tsgReady) return;
    root.dataset.tsgReady = 'true';
    const select = name => root.querySelector('[data-tsg="' + name + '"]');
    const products = JSON.parse(root.querySelector('[data-tsg-index]').textContent);
    const labels = JSON.parse(root.querySelector('[data-tsg-labels]').textContent);
    const cards = [...root.querySelectorAll('[data-chart-id]')];
    const filters = [...root.querySelectorAll('[data-filter]')];
    const input = select('product-search');
    const results = select('search-results');
    const status = select('search-status');
    const selected = select('selected-product');
    const expand = select('expand');
    const updateCount = () => {
      const visible = cards.filter(card => !card.hidden);
      select('chart-count').textContent = visible.length === 1 ? labels.count_one : labels.count_many.replace('{count}', visible.length);
      expand.textContent = visible.some(card => !card.open) ? labels.expand : labels.collapse;
    };
    const closeResults = () => { results.replaceChildren(); status.textContent = ''; };
    const filter = category => {
      selected.classList.remove('tsg-visible');
      input.value = '';
      closeResults();
      filters.forEach(button => {
        const active = button.dataset.filter === category;
        button.classList.toggle('tsg-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach(card => { card.hidden = category !== 'all' && !card.dataset.category.split(' ').includes(category); });
      updateCount();
    };
    const showProduct = product => {
      cards.forEach(card => {
        card.hidden = !product.charts.includes(card.dataset.chartId);
        if (!card.hidden) card.open = true;
      });
      filters.forEach(button => { button.classList.remove('tsg-active'); button.setAttribute('aria-pressed', 'false'); });
      selected.replaceChildren();
      const title = document.createElement('h2');
      title.textContent = product.title;
      const text = document.createElement('p');
      text.textContent = product.charts.length ? labels.selected : labels.missing;
      const reset = document.createElement('button');
      reset.type = 'button';
      reset.textContent = labels.show_all;
      reset.addEventListener('click', () => filter('all'));
      selected.append(title, text, reset);
      selected.classList.add('tsg-visible');
      input.value = product.title;
      closeResults();
      updateCount();
    };
    filters.forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    expand.addEventListener('click', () => {
      const visible = cards.filter(card => !card.hidden);
      const open = visible.some(card => !card.open);
      visible.forEach(card => { card.open = open; });
      updateCount();
    });
    cards.forEach(card => card.addEventListener('toggle', updateCount));
    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase();
      results.replaceChildren();
      status.textContent = '';
      if (query.length < 2) return;
      const matches = products.filter(product => product.title.toLocaleLowerCase().includes(query));
      matches.slice(0, 16).forEach(product => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = product.title;
        button.addEventListener('click', () => showProduct(product));
        results.appendChild(button);
      });
      if (!matches.length) {
        const text = document.createElement('p');
        text.textContent = labels.no_matches;
        results.appendChild(text);
      }
      status.textContent = labels.matches.replace('{count}', matches.length) + (matches.length > 16 ? labels.limited : '');
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeResults();
      if (event.key === 'ArrowDown' && results.querySelector('button')) {
        event.preventDefault();
        results.querySelector('button').focus();
      }
    });
    results.addEventListener('keydown', event => {
      const buttons = [...results.querySelectorAll('button')];
      const current = buttons.indexOf(document.activeElement);
      if (event.key === 'Escape') { closeResults(); input.focus(); }
      else if (event.key === 'ArrowDown') { event.preventDefault(); (buttons[current + 1] || buttons[0])?.focus(); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); if (current <= 0) input.focus(); else buttons[current - 1].focus(); }
    });
    document.addEventListener('click', event => { if (root.isConnected && !event.target.closest('.tsg-search-box')) closeResults(); });
    const aliases = { 'kids-tee': 'youth-tee', 'kids-hoodie': 'youth-hoodie' };
    const openHash = () => {
      let value;
      try { value = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      const id = aliases[value] || value;
      const card = cards.find(item => item.dataset.chartId === id);
      if (!card) return;
      filter('all');
      card.open = true;
      card.scrollIntoView({ behavior: 'auto', block: 'start' });
    };
    const handle = new URL(location.href).searchParams.get('product');
    const product = products.find(item => item.handle === handle);
    if (product) showProduct(product);
    openHash();
    window.addEventListener('hashchange', () => { if (root.isConnected) openHash(); });
    updateCount();
  };
  const initializeAll = () => document.querySelectorAll('[data-thrila-sizing-guide]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
